import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { downloadExcel, getProducts, setImageFromS3 } from '@/api/products';
import Pagination from '@/components/Pagination/index.vue';
import { getQuery, formatJson } from '@/utils/index';
import { exportJson2Excel } from '@/utils/excel';
import VariationPrice from './components/VariationPrice.vue';
import Enabled from '@/components/Enabled/index.vue';
import { AdminModule } from '@/store/modules/admin';
import Inr from '@/components/Inr/index.vue';
import { getRanges } from '@/api/ranges';
import { getCategories } from '@/api/categories';
import { isExcludedToAccess } from '@/common';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.tableKey = 0;
    this.total = 0;
    this.list = [];
    this.listLoading = true;
    this.downloadLoading = false;
    this.category = '';
    this.rangeList = [];
    this.isReadOnly = false;
    this.categoryList = [];
    this.subCategoryList = [];
    this.categoryId = null;
    this.subCategoryId = null;
    this.listQuery = {
      page: 1,
      limit: 10,
      enabled: true,
      name: undefined,
      catalogueCode: undefined,
      featured: undefined,
      rangeId: undefined,
      'category.id': undefined,
      'productsVariation.enabled': true,
      sort: 'id,DESC',
      filter: {
        name: '$contL',
        catalogueCode: '$contL',
        enabled: '$eq',
        featured: '$eq',
        rangeId: '$eq',
        'category.id': '$eq',
        'productsVariation.enabled': '$eq'
      }
    };
    this.settingImageFromS3 = false;
    this.sortOptions = [{
      label: 'ID Ascending',
      key: 'id,ASC'
    }, {
      label: 'ID Descending',
      key: 'id,DESC'
    }];
    this.enableTypeOptions = [{
      key: true,
      value: 'Enable'
    }, {
      key: false,
      value: 'Disabled'
    }];
  }
  activated() {
    this.getList();
    // fetch range
    this.fetchRanges();
  }
  async getList() {
    try {
      this.listLoading = true;
      this.listQuery['category.id'] = undefined;
      if (this.categoryId) {
        this.listQuery['category.id'] = this.categoryId;
      }
      if (this.subCategoryId) {
        this.listQuery['category.id'] = this.subCategoryId;
      }
      const data = await getProducts(getQuery(this.listQuery));
      this.list = data.data;
      this.total = data.total;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  handleFilter() {
    this.listQuery.page = 1;
    this.getList();
  }
  handleCategoryFilter() {
    this.categoryId = undefined;
    this.subCategoryId = undefined;
    this.fetchCategories();
    this.getList();
  }
  handleSubCategoryFilter() {
    this.subCategoryId = undefined;
    if (this.categoryId) {
      this.fetchSubCategories();
    } else {
      this.categoryId = undefined;
    }
    this.getList();
  }
  async fetchRanges() {
    this.rangeList = await getRanges(getQuery({
      enabled: true,
      sort: 'name,ASC',
      filter: {
        enabled: '$eq'
      }
    }));
  }
  async fetchCategories() {
    if (this.listQuery.rangeId) {
      this.categoryList = await getCategories(getQuery({
        enabled: true,
        parentId: true,
        rangeId: this.listQuery.rangeId,
        sort: 'name,ASC',
        filter: {
          enabled: '$eq',
          parentId: '$isnull',
          rangeId: '$eq'
        }
      }));
      if (this.categoryList.length === 0) {
        this.categoryId = undefined;
      }
    } else {
      this.categoryList = [];
    }
  }
  async fetchSubCategories() {
    if (this.categoryId) {
      this.subCategoryList = await getCategories(getQuery({
        enabled: true,
        parentId: this.categoryId,
        rangeId: this.listQuery.rangeId,
        sort: 'name,ASC',
        filter: {
          enabled: '$eq',
          parentId: '$eq',
          rangeId: '$eq'
        }
      }));
      if (this.subCategoryList.length === 0) {
        this.subCategoryId = undefined;
      }
    } else {
      this.subCategoryList = [];
    }
  }
  sortChange(data) {
    const {
      prop,
      order
    } = data;
    if (prop) {
      this.listQuery.sort = `${prop},` + (order === 'ascending' ? 'ASC' : 'DESC');
      this.handleFilter();
    }
  }
  getSortClass(key) {
    const sort = this.listQuery.sort;
    return sort === `${key},ASC` ? 'ascending' : sort === `${key},DESC` ? 'descending' : '';
  }
  async handleDownload() {
    this.downloadLoading = true;
    const tHeader = ['ID', 'Product Name', 'Type', 'Description', 'HSN code'];
    const filterVal = ['id', 'name', 'productType', 'description', 'hsnCode'];
    const productFilter = Object.assign({}, this.listQuery);
    delete productFilter.limit;
    delete productFilter.page;
    const data2 = await getProducts(getQuery(productFilter));
    const data = formatJson(filterVal, data2);
    exportJson2Excel(tHeader, data, this.$tc('route.productManagement.product.title'));
    this.downloadLoading = false;
  }
  isSuperAdmin() {
    // @Todo: Need to change this to id basis.
    return ['Super Admin'].includes(AdminModule.roles.toString());
  }
  hasNoAccess(requiredRoles) {
    return isExcludedToAccess(requiredRoles);
  }
  async handleExcelDownload() {
    this.downloadLoading = false;
    try {
      const queryWithoutPagination = {
        ...this.listQuery
      };
      delete queryWithoutPagination.page;
      delete queryWithoutPagination.limit;
      const blob = await downloadExcel(queryWithoutPagination);
      // Create a blob URL for the Excel file
      const url = window.URL.createObjectURL(blob);
      // Create a temporary link element
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'products.xlsx');
      document.body.appendChild(link);
      // Simulate click to trigger download
      link.click();
      // Clean up
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error downloading Excel:', error);
      this.$message.error('Error downloading Excel');
    } finally {
      // Reset loading state
      this.downloadLoading = false;
    }
  }
  async setImageFromS3(id) {
    try {
      this.settingImageFromS3 = true;
      await setImageFromS3({
        id
      });
      // refresh the list
      await this.getList();
    } catch (error) {
      console.error('Error setting image from S3:', error);
      this.$message.error('Error setting image from S3');
    } finally {
      // Reset loading state
      this.settingImageFromS3 = false;
    }
  }
};
default_1 = __decorate([Component({
  name: 'ProductList',
  components: {
    Pagination,
    Enabled,
    Inr,
    VariationPrice
  }
})], default_1);
export default default_1;